import React from 'react';
import PropTypes from 'prop-types';
import RadioGroupOptionsTable from './RadioGroupOptionsTable';
import TextFormatter from 'utils/TextFormatter';
import { FormattedNumber } from 'react-intl';
import { textUtils } from '../../utils/textUtils';

class SecurityOptionsList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            refreshTransaction: false
        };

        this.onOptionChange = this.onOptionChange.bind(this);
    }

    onOptionChange(code) {
        const { equipmentOptions, orderId, workOrderActions } = this.props;
        const selectedOptions = equipmentOptions.get('selectedOptions');
        const sortedOptions = equipmentOptions
            .getIn(['details', 'serviceCodeList'])
            .sortBy(item => item.get('description'));

        if (selectedOptions) {
            const charges = selectedOptions.filter(option => sortedOptions.some(row => !row.get('isEquipment') && row.get('code') === option.code));
            if (charges.length > 0) {
                charges.forEach(charge => {
                    workOrderActions.equipmentOptionQtySet(orderId, charge.code, 0);
                });

                if (code !== textUtils.security.noOptionSelected) {
                    workOrderActions.equipmentOptionQtySet(orderId, code, 1);
                }
            } else {
                if (code !== textUtils.security.noOptionSelected) {
                    workOrderActions.equipmentOptionQtySet(orderId, code, 1);
                }
            }
        } else {
            if (code !== textUtils.security.noOptionSelected) {
                workOrderActions.equipmentOptionQtySet(orderId, code, 1);
            }
        }
        this.setState({
            refreshTransaction: !this.state.refreshTransaction
        });
    }

    render() {
        const { equipmentOptions } = this.props;
        let selectedOptions = [];
        let options = [];

        if (!equipmentOptions) {
            return null;
        }

        selectedOptions = equipmentOptions.get('selectedOptions');
        const unsortedOptions = equipmentOptions.getIn(['details', 'serviceCodeList']);

        if (unsortedOptions) {
            const sortedOptions = unsortedOptions ? unsortedOptions.sortBy(item => item.get('description')) : [];

            if (sortedOptions) {
                options = sortedOptions.filter(row => !row.get('isEquipment')).map(item => {
                    return {
                        value: item.get('code'),
                        label: <FormattedNumber
                            value={item.get('cost')}
                            style="currency"
                            currency="USD"
                        />,
                        description: item.get('description')
                    }
                }).toJS();
            }

            if (selectedOptions) {
                selectedOptions = selectedOptions.filter(option => option.quantity > 0).map(selectedOpt => {
                    return {
                        value: selectedOpt.code
                    }
                });
            }

            if (options.length === 0) {
                return null;
            }
        } else {
            return null;
        }


        return (
            <div className="security-main-div">
                <div>
                    <h5 className="security-options-title">
                        {TextFormatter.humanizeTitle(textUtils.security.title)}
                    </h5>
                    <RadioGroupOptionsTable
                        includeBlankOption={true}
                        blankOptionLabel={
                            <FormattedNumber
                                value={'0.00'}
                                style="currency"
                                currency="USD"
                            />
                        }
                        options={options}
                        selectedOptions={selectedOptions}
                        onRadioGroupButtonChange={this.onOptionChange}
                    />
                </div>
            </div >
        );
    }
}

SecurityOptionsList.propTypes = {
    equipmentOptions: PropTypes.object,
    orderId: PropTypes.string,
    workOrderActions: PropTypes.object
};

export default SecurityOptionsList;


// WEBPACK FOOTER //
// ./src/components/equipment/SecurityOptionsList.js